import { LogoutIcon } from '../icons';
import { useAuth } from '@/utils/hooks/useAuth';
import { SectionBase } from '../ui/SectionBase';

export const AccountCreatedMessage = () => {
  const { logout } = useAuth();

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white p-4">
      <div className="mb-8 flex justify-center">
        <img src="/logos/growdata-logo-ops-product-dark-green-onwhite.png" alt="Growdata logo" width={480} />
      </div>
      <SectionBase className="max-w-xl">
        <div className="flex flex-col items-center space-y-4 px-4 py-6 text-center">
          <h1 className="text-2xl font-bold text-primary">Account Successfully Created!</h1>
          <p className="text-lg leading-relaxed text-gray-600">
            Please email our support team so they can set you up with your correct account permissions{' '}
            <a href="mailto:support@growdata.com.au" className="font-semibold text-primary hover:underline">
              support@growdata.com.au
            </a>
            .
          </p>
        </div>
      </SectionBase>
      <button
        onClick={() => logout('redirect')}
        className="mt-8 flex items-center gap-2 rounded-md border border-gray-200 bg-white px-6 py-3 text-gray-600 shadow-sm transition-all hover:bg-gray-50 hover:text-primary"
      >
        <LogoutIcon className="h-[20px] w-[20px] fill-current" />
        <span className="font-medium">Logout</span>
      </button>
    </div>
  );
};
